export default [
  {
    key: 'month',
    visible: true
  },
  {
    key: 'units_closed',
    sortable: true,
    visible: true
  },
  {
    key: 'units_pending',
    sortable: true,
    visible: true
  },
  {
    key: 'average_sale_price',
    sortable: true,
    visible: true
  },
  {
    key: 'closed_volume',
    sortable: true,
    visible: true
  },
  {
    key: 'closed_gci',
    label: 'Closed GCI',
    sortable: true,
    visible: true
  },
  {
    key: 'pending_volume',
    sortable: true,
    visible: true
  },
  {
    key: 'pending_gci',
    label: 'Pending GCI',
    sortable: true,
    visible: true
  },
  {
    key: 'closed_company_gci',
    label: 'Closed Company GCI',
    sortable: true,
    visible: true
  },
  {
    key: 'pending_company_gci',
    label: 'Pending Company GCI',
    sortable: true,
    visible: true
  },
  {
    key: 'closed_agent_gci',
    label: 'Closed Agent GCI',
    sortable: true,
    visible: true
  },
  {
    key: 'pending_agent_gci',
    label: 'Pending Agent GCI',
    sortable: true,
    visible: true
  },
];